import { createAction, props } from '@ngrx/store';

export const touchpoint = createAction('[Navigation] touchpoint', props<{ item: string }>());
export const leftMenu = createAction('[Navigation] leftMenu', props<{ item: string }>());
export const tabitem = createAction('[Navigation] tabitem', props<{ item: string }>());
export const url = createAction('[Navigation] url', props<{ item: string }>());



